// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XArticle_XArticle__FYRbA {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  flex: content;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
}

.XArticle_XArticle__FYRbA div.XArticle_XLeft__fkrXf {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.XArticle_XArticle__FYRbA div.XArticle_XLeft__fkrXf div.XArticle_XExpander__IqpKe {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  flex-shrink: 0;
  display: flex;
  flex-grow: 1;
}

.XArticle_XArticle__FYRbA div.XArticle_XClient__Gl2YK {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  flex: content;
}

.XArticle_XArticle__FYRbA div.XArticle_XClient__Gl2YK div.XArticle_XContent__7yOqq {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  flex-shrink: 0;
  display: flex;
  flex: content;
  flex-direction: column;
}

.XArticle_XArticleDate__pp8Am {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  display: flex;
  flex-direction: column;
  vertical-align: bottom;
}

.XArticle_XArticleDate__pp8Am div.XArticle_XRow__xrOJD {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: row;
  flex: content;
  background-color: white;
  font-style: italic;
}

.XArticle_XArticleHeader__9xEzz {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-weight: bold;
  display: flex;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/X/components/containers/XArticle.module.scss","webpack://./src/X/styles/common.scss"],"names":[],"mappings":"AAsBA;ECnBI,kBAAA;EACA,yBAAA;EACA,mBAAA;EAKA,cAAA;EDeA,aAAA;EACA,mBAAA;EAEA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AApBJ;;AAsBA;EC/BI,kBAAA;EACA,yBAAA;EACA,mBAAA;EAKA,cAAA;ED2BA,aAAA;EACA,sBAAA;AAjBJ;;AAmBA;ECrCI,kBAAA;EACA,yBAAA;EACA,mBAAA;EAKA,cAAA;EDiCA,aAAA;EACA,YAAA;AAdJ;;AAiBA;EC5CI,kBAAA;EACA,yBAAA;EACA,mBAAA;EAKA,cAAA;EDwCA,aAAA;EACA,sBAAA;EAEA,aAAA;AAbJ;;AAgBA;ECrDI,kBAAA;EACA,yBAAA;EACA,mBAAA;EAKA,cAAA;EDiDA,aAAA;EACA,aAAA;EACA,sBAAA;AAXJ;;AAuBA;ECtEI,kBAAA;EACA,yBAAA;EACA,mBAAA;EDsEA,aAAA;EACA,sBAAA;EAEA,sBAAA;AAnBJ;;AAsBA;EC9EI,kBAAA;EACA,yBAAA;EACA,mBAAA;EASA,2BAAA;EACH,yBAAA;EAIA,iBAAA;EDiEG,aAAA;EACA,mBAAA;EAEA,aAAA;EACA,uBAAA;EAGA,kBAAA;AAfJ;;AAqBA;EC9FI,kBAAA;EACA,yBAAA;EACA,mBAAA;ED8FA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAhBJ","sourcesContent":["@use \"../../styles/common\";\n@use \"../../styles/themes\";\n\n@mixin XBorder {\n    background-color: #898989;\n}\n\n@mixin XArticleBackground {\n    background-color: white;\n}\n\n@mixin XTopBorderMixin {\n    background: rgb(1,1,1);\n    background: -moz-linear-gradient(0deg, rgba(1,1,1,1) 0%, rgba(135,135,135,1) 100%);\n    background: -webkit-linear-gradient(0deg, rgba(1,1,1,1) 0%, rgba(135,135,135,1) 100%);\n    background: linear-gradient(0deg, rgba(1,1,1,1) 0%, rgba(135,135,135,1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#010101\",endColorstr=\"#878787\",GradientType=1);\n}\n\n//----------------------------------------------------------------------------------------------------\n// XArticle\n//----------------------------------------------------------------------------------------------------\n.XArticle {\n    @include common.nodebug;\n    @include common.noshrink;\n    display: flex;\n    flex-direction: row;\n    //flex-grow: 1;\n    flex: content;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    margin-left: 15px;\n    margin-right: 15px;\n}\n.XArticle div.XLeft{\n    @include common.nodebug;\n    @include common.noshrink;\n    display: flex;\n    flex-direction: column;        \n}\n.XArticle div.XLeft div.XExpander{\n    @include common.nodebug;\n    @include common.noshrink;\n    display: flex;\n    flex-grow: 1;\n}\n\n.XArticle div.XClient{\n    @include common.nodebug;\n    @include common.noshrink;\n    display: flex;\n    flex-direction: column;\n    //flex-grow: 1;\n    flex: content;\n}\n\n.XArticle div.XClient div.XContent{\n    @include common.nodebug;\n    @include common.noshrink;    \n    display: flex;\n    flex: content;\n    flex-direction: column;\n    //width: 100%;\n    //flex-grow: 1;\n    //word-break: break-all;\n    //text-wrap: unset;\n    //overflow-wrap: anywhere;\n    \n    //hyphens: manual;\n}\n//----------------------------------------------------------------------------------------------------\n// XArticleDate\n//----------------------------------------------------------------------------------------------------\n.XArticleDate {\n    @include common.nodebug;\n    display: flex;\n    flex-direction: column;\n    // margin-left: 10px;\n    vertical-align: bottom;\n}\n\n.XArticleDate div.XRow {\n    @include common.nodebug;\n    @include common.noselect;\n    display: flex;\n    flex-direction: row;\n    //flex-grow: 1;\n    flex: content;\n    background-color: white;    \n    //padding-top: 5px;\n    //padding-bottom: 5px;\n    font-style: italic;\n}\n//----------------------------------------------------------------------------------------------------\n// XArticleHeader\n//----------------------------------------------------------------------------------------------------\n\n.XArticleHeader {\n    @include common.nodebug;\n    height: 28px;\n    line-height: 28px;\n    text-align: center;\n    font-weight: bold;\n    display: flex;\n    margin-bottom: 10px;\n    //flex-grow: 1;\n}\n\n","\n@mixin nodebug\n{\n    outline-width: 0px;\n    outline-color: chartreuse;\n    outline-style: none;\n}\n\n@mixin noshrink\n{\n    flex-shrink: 0;\n}\n\n@mixin noselect {\n    -webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n@mixin nomouse {\n    pointer-events: none;\n}\n\n@mixin border-box {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XArticle": `XArticle_XArticle__FYRbA`,
	"XLeft": `XArticle_XLeft__fkrXf`,
	"XExpander": `XArticle_XExpander__IqpKe`,
	"XClient": `XArticle_XClient__Gl2YK`,
	"XContent": `XArticle_XContent__7yOqq`,
	"XArticleDate": `XArticle_XArticleDate__pp8Am`,
	"XRow": `XArticle_XRow__xrOJD`,
	"XArticleHeader": `XArticle_XArticleHeader__9xEzz`
};
export default ___CSS_LOADER_EXPORT___;
